// extracted by mini-css-extract-plugin
export default {"wrapper":"ESFJfO0ErVH1xe3b2rOU"};